import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogInputItem from './item';
import { MediaQuery as MQ } from '../../shared/media-query';

class Component extends BaseComponent {
    render({ input }) {
        return (
            <catalog-input>
                {this.renderLabel(input.items[0].key)}
                {input.items.map(item => (<CatalogInputItem item={item} callback={this.update} />))}
                {this.renderKCButton(input.items[0].key)}
            </catalog-input>
        );
    }

    renderLabel = (filter_type) => {
        if (filter_type == 'topic') {
            if (MQ.isMobile()) {
                return (
                    <div
                        className='has-text-center has-padding-10-top has-padding-10-bottom'
                    >
                        Filter by Topic:
                    </div>
                );
            }

            return (<span>Filter<br />by Topic:</span>);
        }

        return null;
    }

    renderKCButton = (filter_type) => {
        if (filter_type == 'divination') {
            return (<CatalogInputItem item={{ key: 'kc' }} />);
        }

        return null;
    }

    update = (updated_item) => {
        let updated_input = this.props.input;
        let updated_items = updated_input.items;

        if (updated_item.key == 'divination') {
            // clear other radio buttons
            updated_items.forEach(item => {
                if (updated_item.value == 'all' || item.value != updated_item.value) {
                    if (item.value != updated_item.value) {
                        document.getElementById(item.value).classList.remove('checked');
                    }

                    item.checked = false;
                }
            });
        }

        updated_input.items = updated_items;

        this.setState({ input: updated_input });
    }
}

export default connect()(Component);
